import { ILicensePageHelper, ILicenseSeviceHelper, ILicenseTemplateHelper } from './index';

/**
 * This class provides helper functions for the license page.
 *
 * @export
 * @class LicensePageHelper
 * @implements {LicensePageHelper}
 */
export class LicensePageHelper implements ILicensePageHelper {

    private licenseServiceHelper: ILicenseSeviceHelper;
    private licenseTemplateHelper: ILicenseTemplateHelper;
    private targetElement: HTMLDivElement;


    /**
     * Creates an instance of LicensePageHelper.
     *
     * @param {ILicenseSeviceHelper} licenseServiceHelper The license service helper.
     * @param {ILicenseTemplateHelper} licenseTemplateHelper The license template helper.
     * @param {HTMLDivElement} targetElement The target element.
     * @memberof LicensePageHelper
     */
    public constructor(licenseServiceHelper: ILicenseSeviceHelper, licenseTemplateHelper: ILicenseTemplateHelper, targetElement: HTMLDivElement) {
        this.targetElement = targetElement;
        this.licenseServiceHelper = licenseServiceHelper;
        this.licenseTemplateHelper = licenseTemplateHelper;
    }

    /**
     * Opens the about page.
     *
     * @param {boolean} [isLoggedIn] Whether the user is logged in.
     * @memberof LicensePageHelper
     */
    public renderAboutPage(isLoggedIn?: boolean): void {
        this.targetElement.innerHTML = '';
        // TODO: Check if required: this.viewStyleManager.updateStyle('wd-style-colors-0');
        this.licenseTemplateHelper.renderLicenseContent(this.targetElement, this.licenseServiceHelper, isLoggedIn);
    }
}